import  imagem  from '../assets/img/isaacfoto.jpg';

export const Apresentacao = () => {
    return (
        <>
            <div className="container area-apresentacao">
                <div className="d-flex align-items-center flex-wrap justify-content-around">
                    {/* Lado esquerdo */}
                    <div className=" col-12 col-md-6 ">
                        <h2>Olá, seja bem-vindo!</h2>
                        <h1><strong>Eu sou o Isaac Wandermurem</strong></h1>
                        <p>Futuro desenvolvedor, entusiasta em tecnologia <br />e em busca de uma oportunidade de emprego.</p>
                    </div>

                    {/* Lado direito */}
                    <div className=" d-flex justify-content-center align-items-center areaisaac">
                        <div>
                            <img src={imagem} alt="Isaac Wandermurem" className=" imagem-isaac" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}